import React, { useState, useEffect } from "react";
import "../../Common.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { makeStyles } from "@material-ui/core/styles";
import { TableRow, Table, TableBody, TableHead } from "@material-ui/core";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { LIMIT, PAGE } from "../../../reducer-store/constants";
// import Collapse from "@mui/material/Collapse";
import Box from "@material-ui/core/Box";
import Typography from "@mui/material/Typography";
// import IconButton from "@mui/material/IconButton";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Row, Col, Container } from "react-bootstrap";
import { DownloadForOffline } from "@mui/icons-material";
import { green } from "@mui/material/colors";
import GppGoodRoundedIcon from "@mui/icons-material/GppGoodRounded";
import { bindActionCreators } from "redux";
import * as Actions from '../../../reducer-store/actions/paymentsAction'
import { useDispatch, useSelector } from "react-redux";
import Master from '../../../svg_icons/mastro.png';
import Visa from '../../../svg_icons/visa.png';
import moment from "moment";
import { fileSignedURL } from "../../../reducer-store/actions/authActions";
import { toast } from "react-toastify";
import MUIDataTable from "mui-datatables";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CircularProgress, styled } from "@mui/material";
import { LIST_OF_PAYMENTS_ERROR } from "../../../reducer-store/ActionTypes";
import pdfIcon from "../../../svg_icons/pdfIcon.png";
import { enhanceTableColumns } from "../../../utils/muiDataTableSortUtils";

const useStyles = makeStyles(() => ({
    boxBorder1: {
        textAlign: "center",
        margin: "20px 0px",
    },
    TransferInitiated: {
        color: "#00a651",
    },
    line: {
        backgroundColor: "#00a651",
        width: "100%",
        height: "5px",
        marginTop: "2.5%",
    },
    Right: {
        textAlign: "end",
    },
    Left: {
        textAlign: "start",
    },
    saveButton: {
        borderRadius: "40px !important",
        backgroundColor: "#00A651 !important",
        border: "1px solid #00A651 !important",
        color: "#ffffff !important",
        padding: "0 35px !important",
        height: "40px !important",
        fontFamily: 'Arial !important',
        fontSize: '14px !important',
        textTransform: "capitalize",
    },
}));

const theme = createTheme({
    components: {
        MuiTableHead: {
            styleOverrides: {
                root: {
                    "& .css-1ygcj2i-MuiTableCell-root": {
                        fontweight: "bold",
                        backgroundColor: '#FFFFFF'
                    },
                    "& .tss-1h9t3sl-MUIDataTableHeadCell-sortAction": {
                        display: "-webkit-box"
                    },
                    "& .tss-1fbujeu-MUIDataTableHeadCell-toolButton": {
                        backgroundColor: '#FFFFFF'
                    },
                    '.tss-1akey0g-MUIDataTableHeadCell-data': {
                        fontSize: '15px'
                    },
                    "& .tss-1832qqn-MUIDataTableHeadRow-root": {
                        borderBottomColor: '#000',
                        borderBottomWidth: '1.2px',
                    },
                    "& .tss-10syd3x-MUIDataTableHeadCell-root": {
                        fontSize: '15px',
                    }
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: "Arial"
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    fontFamily: "Arial",
                },
                head: {
                    backgroundColor: "#FFFFFF"
                },
                footer: {
                    backgroundColor: "#FFFFFF"
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                colorInherit: {
                    backgroundColor: '#E53D12',
                    borderRadius: '4px',
                    color: 'white',
                    marginRight: '25px',
                }
            }
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    "&:nth-child(odd)": {
                        backgroundColor: "#F4F4F4"
                    },
                }
            }
        },
        MuiTableBody: {
            styleOverrides: {
                root: {
                    "& .css-1ex1afd-MuiTableCell-root": {
                        width: "13%",
                    }
                }
            }
        },
        MuiTablePagination: {
            styleOverrides: {
                root: {
                    "& .MuiTablePagination-displayedRows": {
                        marginTop: "9%"
                    },
                }
            }
        },
    }
});

interface RefundProps {
    [x: string]: any;
    id: number;
    amount: string;
    payment_id: string;
    reason: string;
    status: string;
    refund_id: string;
    created: string;
};

const All_Transaction: React.FC = () => {
    const classes = useStyles();
    const [page, setPage] = useState(PAGE);
    const AuthToken = useSelector((state: any) => state.auth);
    const { token } = AuthToken;
    const dispatch = useDispatch();
    const { studentPaymentsList, generatePaymentUrl } = Actions;
    const listOfPayment = useSelector((state: any) => state.payment);
    const { payments } = listOfPayment;
    const status = ""
    const [data, setData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    // const StyledTableCell = styled(TableCell)(({ theme }) => ({
    //     [`&.${tableCellClasses.head}`]: {
    //         backgroundColor: theme.palette.common.black,
    //         color: theme.palette.common.white,
    //     },
    //     [`&.${tableCellClasses.body}`]: {
    //         fontSize: 14,
    //     },
    // }));

    // const StyledTableRow = styled(TableRow)(({ theme }) => ({
    //     "&:nth-of-type(odd)": {
    //         backgroundColor: theme.palette.action.hover,
    //     },
    //     // hide last border
    //     "&:last-child td, &:last-child th": {
    //         border: 0,
    //     },
    // }));

    // const handleSearch = (value: string) => {
    //     setSearch(value);
    // };

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            dispatch({ type: LIST_OF_PAYMENTS_ERROR });
            const newPaymentList = await studentPaymentsList(status, token);
            renderDataTable(newPaymentList);
            setIsLoading(false);
        })();
    }, [page]);

    const paymentStatus = (value: number) => {
        switch (value) {
            case 0:
                return "Failed";
            case 1:
                return "Received";
            case 2:
                return "Failed";
            case 3:
                return "Cancelled";
            case 4:
                return "Refund Requested";
            case 5:
                return "Refunded";
        }
    };

    const paymentUrl = async (paymentId: any) => {
        let obj = {
            "payment_id": paymentId,
        }
        const resData = await generatePaymentUrl(obj, token);

        if (!resData?.error) {
            toast.success("Invoice generated successfully");
            setTimeout(() => {
                navigateToExternalUrl(resData?.invoice_url, true);
            }, 2000)
        }
    }

    const renderDataTable = (paymentsList: any) => {
        if (!paymentsList?.data?.length) {
            setData([]);
            return;
        }
        var localArr: any = []
        const rowsDataTable = paymentsList.data.map((row: any, index: number) => {
            localArr.push(row?.symbol.concat(" ", Number(row?.total_amount).toFixed(2)))
            return {
                id: index + 1,
                date: row?.paid_on ? moment(row?.paid_on).format("YYYY-MM-DD") : "--",
                amount: localArr[index],
                // amount: <>{row.symbol ? row?.symbol : "--"} {" "} {Number(row?.total_amount).toFixed(2)}</>,
                status: paymentStatus(row?.status) || "--",
                // transaction_id: <>{row.PaymentInfos.length ? row.PaymentInfos[0]?.transaction : "--"}</>,
                transaction_id: row.PaymentInfos.length > 0 && row.PaymentInfos[0]?.transaction !== null ? row.PaymentInfos[0]?.transaction : "--",
                fee_type: row?.details ? row?.details : row?.feeType ? row?.feeType : "--",
                // fee_type: <>{row?.details ? row?.details : row?.feeType ? row?.feeType : "--"}</>,
                instrument_logo: row?.PaymentInfos[0]?.network != null ? cardshow(row?.PaymentInfos[0]?.network) : "--",
                transaction_acc: row?.PaymentInfos[0]?.last4 != null ? `**** **** **** ${row?.PaymentInfos[0]?.last4}` : "--",
                invoice: <>{row.status == "1" ?
                    <span onClick={() => paymentUrl(row?.payment_id)}>
                        <DownloadForOffline sx={{ fill: green[600], cursor: 'pointer' }} />
                    </span> : null}</>,
                transfer_initiate: row?.created_at,
                transfer_complete: row?.paid_on,
                paymentgateway_id: row?.payment_id,
                payStatus: row?.status,
                gateway_name: row?.gateway_name,
            };
        });
        setData(rowsDataTable)
    };

    const columns = [
        {
            label: 'Sr No',
            name: "id",
        },
        {
            label: 'Date',
            name: "date",
        },
        {
            label: 'Amount',
            name: "amount",
        },
        {
            label: 'Status',
            name: "status",
        },
        {
            label: 'Transaction ID',
            name: "transaction_id",
        },
        {
            label: 'Payment Details',
            name: "fee_type",
            options: {
                sort: true,
            }
        },
        {
            label: 'Card Type',
            name: "instrument_logo",
            options: {
                sort: false,
            }
        },
        {
            label: 'Transaction Acc',
            name: "transaction_acc",
        },
        {
            label: 'Invoice',
            name: "invoice",
            options: {
                sort: false,
            }
        },
        {
            label: "transfer_initiate",
            name: "transfer_initiate",
            options: {
                display: false,
            }
        },
        {
            label: "transfer_complete",
            name: "transfer_complete",
            options: {
                display: false,
            }
        },
        {
            label: 'Payment Gateway Id',
            name: "paymentgateway_id",
            options: {
                display: false,
            }
        },
        {
            label: 'payStatus',
            name: "payStatus",
            options: {
                display: false,
            }
        },
        {
            label: '',
            name: "gateway_name",
            options: {
                display: false,
            }
        },
    ];

    const options = {
        search: false,
        print: false,
        viewColumns: false,
        filter: false,
        download: false,
        responsive: "vertical" as const,
        expandableRows: true,
        expandableRowsHeader: false,
        expandableRowsOnClick: false,
        selectableRows: "none" as const,
        rowsPerPageOptions: [],
        fixedHeader: false,
        textLabels: {
            body: {
                noMatch: isLoading ? (
                    <Box style={{ alignItems: 'center', margin: "0 auto", justifyContent: "center" }}>
                        <CircularProgress sx={{ color: "#707070" }} />
                    </Box>
                ) : (
                    'Sorry, there is no matching data to display'
                ),
            },
        },
        renderExpandableRow: (rowData: any) => {
            return (
                <TableRow >
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
                        <Box className={classes.boxBorder1}>
                            <div className="row">
                                <Col lg="4" sm="4" xs="12" className={classes.Right}>
                                    <Typography
                                        variant="h6"
                                        gutterBottom
                                        component="div"
                                        className={classes.TransferInitiated}
                                    >
                                        <GppGoodRoundedIcon />
                                        Transfer Initiated
                                    </Typography>
                                    <Typography
                                        variant="subtitle1"
                                        gutterBottom
                                        component="div"
                                    >
                                        Timestamp : {rowData[8] ? moment(rowData[8]).format("MMM D, YYYY | h:mm:ss A") : "--"}
                                    </Typography>
                                </Col>
                                <Col lg="4" sm="4" xs="12">
                                    <div className={classes.line}></div>
                                </Col>

                                <Col lg="4" sm="4" xs="12" className={classes.Left}>
                                    <Typography
                                        variant="h6"
                                        gutterBottom
                                        component="div"
                                        className={classes.TransferInitiated}
                                    >
                                        <GppGoodRoundedIcon />
                                        Transfer {!rowData[12] ? "Cash" : paymentStatus(rowData[11])}
                                    </Typography>
                                    <Typography
                                        variant="subtitle1"
                                        gutterBottom
                                        component="div"
                                    >
                                        Timestamp :  {rowData[9] ? moment(rowData[9]).format("MMM D, YYYY | h:mm:ss A") : "--"}
                                    </Typography>
                                    <Typography
                                        variant="subtitle1"
                                        gutterBottom
                                        component="div"
                                    >
                                        {!rowData[12] ? "Cash Transaction" : "Payment Gateway"} ID : {rowData[10] || "--"}
                                    </Typography>
                                </Col>
                            </div>
                        </Box>
                    </TableCell>
                </TableRow >
            );
        },
    };

    const cardshow = (value: any) => {
        if (value?.length === 0) {
            return "---";
        }
        switch (value?.brand) {
            case "visa":
                return <img src={Visa} alt="visa" />;
            case "master":
                return <img src={Master} alt="visa" />;
            default:
                return <img src={Visa} alt="visa" />;
        }
    };

    const navigateToExternalUrl = async (urlName: string, shouldOpenNewTab: boolean = true) => {
        // const newData: { url: string, msg: string, error: boolean } = await fileSignedURL(urlName && urlName, token);
        // const { url, msg, error } = newData;
        // if (error) {
        //     toast.error(msg);
        //     return;
        // }
        shouldOpenNewTab ? window.open(urlName, "_blank") : window.location.href = urlName;
        return;
    }

    return (
        <>
            <ThemeProvider theme={theme}>
                <MUIDataTable
                    title={""}
                    data={data}
                    columns={enhanceTableColumns(columns)}
                    options={options}
                />
            </ThemeProvider>
        </>);
};
export default All_Transaction;

// {/* <div>
//     <Table className="communication-table" aria-label="simple table">
//         <TableHead>
//             <TableRow>
//                 <TableCell />
//                 <StyledTableCell align="left" component="th">
//                     Invoice
//                 </StyledTableCell>
//                 {/* <StyledTableCell align="left" component="th">
//                                 Payments Details
//                             </StyledTableCell> */}
//                 <StyledTableCell align="left" component="th">
//                     Amount
//                 </StyledTableCell>
//                 <StyledTableCell align="left" component="th">
//                     Transaction ID
//                 </StyledTableCell>
//                 <StyledTableCell align="left" component="th">
//                     Fee Type
//                 </StyledTableCell>
//                 <StyledTableCell align="left" component="th">
//                     Instrument Logo
//                 </StyledTableCell>
//                 <StyledTableCell align="left" component="th">
//                     Transaction Acc
//                 </StyledTableCell>
//             </TableRow>
//         </TableHead>
//         <TableBody>
//             {!payments ? (
//                 <TableRow>
//                     <StyledTableCell align="center" colSpan={6}>
//                         Loading...
//                     </StyledTableCell>
//                 </TableRow>
//             ) : payments.data.length > 0 ? (
//                 payments.data.map((row: any) => <Row key={row.id} row={row} />)
//             ) :
//                 (
//                     <TableRow key="test1">
//                         <StyledTableCell component="td" align="center" colSpan={7}>
//                             No Data Found
//                         </StyledTableCell>
//                     </TableRow>
//                 )
//             }
//         </TableBody>
//     </Table>
//     <PaginationComponent
//         page={page}
//         setPage={setPage}
//         paginationData={payments && payments.meta} />
// </div> */}